import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useConnectWs from "../../../hooks/useConnectWs";
import { formatNumber, formatNumberOnly } from "../../../utils/Helpers";

const Statistic = () => {
  formatNumber();
  const { t } = useTranslation();
  const [api, setApi] = useConnectWs();
  const [currentBlock, setCurrentBlock] = useState(null);
  const [currentBlockTime, setCurrentBlockTime] = useState(0);
  const [finalized, setFinalized] = useState(null);
  const [finalizedTime, setFinalizedTime] = useState(0);

  useEffect(() => {
    if (api) {
      subscribeNewHeads();
      subscribeFinalizedHeads();
    }
    window.currentBlockOldTime = moment().unix();
    window.finalizedOldTime = moment().unix();
    return () => {
      window?.unSubscribeNewHeads && window?.unSubscribeNewHeads();
      window?.unSubscribeFinalizedHeads && window?.unSubscribeFinalizedHeads();
    };
  }, [api]);

  const subscribeNewHeads = async () => {
    window.unSubscribeNewHeads = await api.rpc.chain.subscribeNewHeads((header) => {
      setCurrentBlock(formatNumberOnly(header.number?.toNumber()));
      setCurrentBlockTime(moment().unix() - (window.currentBlockOldTime || 0));
      window.currentBlockOldTime = moment().unix();
    });
  };

  const subscribeFinalizedHeads = async () => {
    window.unSubscribeFinalizedHeads = await api.rpc.chain.subscribeFinalizedHeads((header) => {
      setFinalized(formatNumberOnly(header.number?.toNumber()));
      setFinalizedTime(moment().unix() - (window.finalizedOldTime || 0));
      window.finalizedOldTime = moment().unix();
    });
  };

  return (
    <div className="statistic">
      <div className="box">
        <div className="top">
          <div className="image">
            <img src="/images/dashboard1.svg" alt="" />
          </div>
          <div className="title">{t("dashboard.Rivius Testnet")}</div>
          <div className="description">{t("dashboard.Rivius Development")}</div>
        </div>

        <div className="bottom">
          <div className="type1">
            <img src="/images/dashboard4.svg" alt="" />
            {t("dashboard.View report")}
          </div>
        </div>
      </div>
      <div className="box">
        <div className="top">
          <div className="image">
            <img src="/images/dashboard2.svg" alt="" />
          </div>
          <div className="title">{t("dashboard.Metadata")}</div>
          <div
            className="description"
            dangerouslySetInnerHTML={{ __html: t("dashboard.Lorem dimsum") }}
          ></div>
        </div>
        <div className="bottom">
          <div className="type1">{t("dashboard.Show Metadata")}</div>
        </div>
      </div>
      <div className="box">
        <div className="top">
          <div className="image">
            <img src="/images/dashboard1.svg" alt="" />
          </div>
          <div className="title">{t("dashboard.Current Block")}</div>
          <div className="number">{currentBlock || "loading..."}</div>
        </div>
        <div className="bottom">
          <div className="type3">
            <img src="/images/dashboard5.svg" alt="" />
            {currentBlockTime || 0}
          </div>
        </div>
      </div>
      <div className="box">
        <div className="top">
          <div className="image">
            <img src="/images/dashboard1.svg" alt="" />
          </div>
          <div className="title">{t("dashboard.Finalized")} </div>
          <div className="number">{finalized || "loading..."}</div>
        </div>
        <div className="bottom">
          <div className="type3">
            <img src="/images/dashboard5.svg" alt="" />
            {finalizedTime || 0}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statistic;
